export const MUNICIPIOS_CONVOCACAO_TESTE = [355640, 354970];

export const getMunicipioId = (acessoAtivo) =>
  acessoAtivo?.cidade ??
  acessoAtivo?.cdCidade ??
  acessoAtivo?.ibge ??
  acessoAtivo?.codigoMunicipio;

export const municipioPodeAcessarConvocacao = (acessoAtivo) =>
  MUNICIPIOS_CONVOCACAO_TESTE.includes(Number(getMunicipioId(acessoAtivo)));
